import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceForMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceForMarkerController.php
* @route '/api/marker/{wiki_place}'
*/
const GetWikiPlaceForMarkerController = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiPlaceForMarkerController.url(args, options),
    method: 'get',
})

GetWikiPlaceForMarkerController.definition = {
    methods: ["get","head"],
    url: '/api/marker/{wiki_place}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceForMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceForMarkerController.php
* @route '/api/marker/{wiki_place}'
*/
GetWikiPlaceForMarkerController.url = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_place: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_place: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_place: typeof args.wiki_place === 'object'
        ? args.wiki_place.id
        : args.wiki_place,
    }

    return GetWikiPlaceForMarkerController.definition.url
            .replace('{wiki_place}', parsedArgs.wiki_place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceForMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceForMarkerController.php
* @route '/api/marker/{wiki_place}'
*/
GetWikiPlaceForMarkerController.get = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiPlaceForMarkerController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetWikiPlaceForMarkerController::__invoke
* @see app/Http/Controllers/WikiPlace/GetWikiPlaceForMarkerController.php
* @route '/api/marker/{wiki_place}'
*/
GetWikiPlaceForMarkerController.head = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiPlaceForMarkerController.url(args, options),
    method: 'head',
})

export default GetWikiPlaceForMarkerController